import { lazy } from "react";
import FreeUserGate from "../Component/Subscription/flag/FreeUserGate";

const MainSubscriptionPage = lazy(() =>
  import("../Component/SubscriptionFeeBilling/MainSubscripttionPage")
);
const Security = lazy(() => import("../Component/Security/Security"));
const AiCreditUsage = lazy(() => import("../Component/AiCredits/AiCreditUsage"));
const OnlineWallet = lazy(() => import("../Component/OnlineWalletAndPayment/OnlineWallet"));
const OnlineWalletLedgerDeatails = lazy(() =>
  import("../Component/OnlineWalletAndPayment/OnlinewalletledgerDetails")
);
const SendInivatation = lazy(() => import("../Component/CommonFunctionality/SendInivatation"));
const AutopayMandatePage = lazy(() =>
  import("../Component/AutopayMandate/AutopayMandatePage")
);

const billingRoutes = [
  // Free users (Free User Access list) get a notice instead of these two.
  {
    path: "/subscription-billing",
    element: (
      <FreeUserGate>
        <MainSubscriptionPage />
      </FreeUserGate>
    ),
    protected: false,
  },
  { path: "/security", element: <Security />, protected: true },
  { path: "/ai-credit-usage", element: <AiCreditUsage />, protected: true },
  { path: "/online-wallet", element: <OnlineWallet />, protected: true },
  {
    path: "/online-wallet-ledger-detail",
    element: <OnlineWalletLedgerDeatails />,
    protected: true,
  },
  { path: "/Invitation-by-sales-person", element: <SendInivatation />, protected: true },
  {
    path: "/autopay-mandate",
    element: (
      <FreeUserGate>
        <AutopayMandatePage />
      </FreeUserGate>
    ),
    protected: true,
  },
];

export default billingRoutes;
